var _circle, _path, _path2, _path3, _path4, _circle2, _circle3, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#3DCBB1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 34.375C18.6193 34.375 17.5 33.2557 17.5 31.875C17.5 30.4943 18.6193 29.375 20 29.375",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34.375C41.3807 34.375 42.5 33.2557 42.5 31.875C42.5 30.4943 41.3807 29.375 40 29.375",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 23.75L23.75 20",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 23.75L36.25 20",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.75,
    cy: 18.75,
    r: 1.25,
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.25,
    cy: 18.75,
    r: 1.25,
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 23.75H28.125C24.5895 23.75 22.8217 23.75 21.7233 24.8862C20.625 26.0224 20.625 27.8512 20.625 31.5086C20.625 35.1661 20.625 36.9948 21.7233 38.131C22.8217 39.2672 24.5895 39.2672 28.125 39.2672H29.4067C30.3961 39.2672 30.7452 39.4716 31.4271 40.2141C32.1812 41.0353 33.3489 42.1312 34.4053 42.3864C35.9067 42.7492 36.0749 42.2474 35.7399 40.8164C35.6445 40.4087 35.4065 39.757 35.6575 39.3772C35.7981 39.1645 36.0324 39.1122 36.5009 39.0076C37.2402 38.8426 37.8498 38.5726 38.2767 38.131C39.375 36.9948 39.375 35.1661 39.375 31.5086C39.375 27.8512 39.375 26.0224 38.2767 24.8862C37.1783 23.75 35.4105 23.75 31.875 23.75Z",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.875 33.75C27.5876 34.509 28.7221 35 30 35C31.2779 35 32.4124 34.509 33.125 33.75",
    stroke: "#F3F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2612 28.75H26.25",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7612 28.75H33.75",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChat);
export default __webpack_public_path__ + "static/media/ai_chat.391908e467135e00bfa83043a3931a46.svg";
export { ForwardRef as ReactComponent };